
import { useSetAppSearch } from "@/components/routes/app-route.hooks";
import { MenuItemProps, MenuCheckboxItem } from "@/components/ui/primitives/menu-item";
import { env } from "@/env.setup";
import { useAppFilter } from "@/hooks/use-app-filter";

export function AccessibilityLayerFilterItem({ variant }: MenuItemProps) {
    const { set } = useSetAppSearch()
    const { isAccessibilityLayerFilterEnabled } = useAppFilter();

    return (
        <MenuCheckboxItem
            variant={variant}
            checked={isAccessibilityLayerFilterEnabled}
            disabled={env.MODE !== "development"}
            onClick={() => {
                set(({ f, ...prev }) => ({
                    ...prev,
                    f: {
                        ...f,
                        accessibility: !isAccessibilityLayerFilterEnabled,
                    }
                }))
            }}
        >
            Show Accessible Background
        </MenuCheckboxItem>
    )
}